module.exports = __webpack_public_path__ + "img/services-portocaliu.a69e13ca.svg";